import pluralize from 'pluralize';
import { ResourceTableItem, ResourcesTable } from './ResourcesTable';

import { FailedToLoad } from '@cast/shared-messages-ui';

import {
  Search,
  SearchProvider,
  useSearchContext,
} from '@cast/shared-search-ui';

import { Typography, Box, Stack, tokens } from '@cast/design-system';

type ResourceContentProps = {
  isError?: boolean;
  refetch?: () => void;
};

const ResourceContent = ({ isError, refetch }: ResourceContentProps) => {
  const searchCtx = useSearchContext();
  return (
    <Stack>
      <Stack
        width="100%"
        sx={{
          backgroundColor: 'grey.100',
          border: '1px solid',
          borderColor: tokens.theme.border.structural.neutral,
          borderRadius: '8px 8px 0px 0px',
          padding: '12px 20px',
        }}
      >
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          mb={16}
        >
          <Typography variant="A2">
            {pluralize('resource', searchCtx?.data?.length ?? 0, true)}
          </Typography>
        </Box>
        {!isError && <Search />}
      </Stack>
      {isError ? (
        <Stack padding={16}>
          <FailedToLoad title="Failed to load resources" refresh={refetch} />
        </Stack>
      ) : (
        <ResourcesTable />
      )}
    </Stack>
  );
};

type Props = {
  resources?: ResourceTableItem[];
  isLoading: boolean;
  isError?: boolean;
  refetch: () => void;
};

export const Resources = ({
  resources,
  isLoading,
  isError,
  refetch,
}: Props) => {
  return (
    <SearchProvider data={resources} isLoading={isLoading}>
      <ResourceContent isError={isError} refetch={refetch} />
    </SearchProvider>
  );
};
